module.exports = __webpack_public_path__ + "media/images/Blog-Previous-Arrow-653c88fc70e3894dfee0cafaebcf8a36.png";